import URI from 'urijs'
import { API_BASE } from '../../../shared/constants/Api'

export const SUPPLIERS_LIST = (params) => { return URI(`${API_BASE}/api/v2/suppliers/`).addSearch(params) }
export const SUPPLIER = ({id, ...params}) => { return URI(`${API_BASE}/api/v2/suppliers/${id}/`).addSearch(params) }
export const SUPPLIER_COMPANY_NAMES = (params) => { return URI(`${API_BASE}/api/v2/suppliers/autocomplete`).addSearch(params) }
export const SUPPLIER_COMPANY_INFO = (params) => { return URI(`${API_BASE}/api/v2/suppliers/autocomplete/get_info`).addSearch(params) }
